import React, { Dispatch } from 'react'
import { ReportInspectorAction, ReportInspectorState } from '../store';
import { Table } from '../../../../../components/common/Table';
import { useFormulaLibrary } from '../../../../../hooks/formulas/use-formula-library';
import { Group, Select, Switch, TextInput } from '@mantine/core';
import { FormulaDetails } from './FormulaDetails';

type FormulaTabProps = {
    state: ReportInspectorState
    dispatch: Dispatch<ReportInspectorAction>
    sites: any[]
}

export const FormulasTab = ({ dispatch, state, sites }: FormulaTabProps) => {
    const columns = [
        { text: 'PK', field_code: 'formula_pk' },
        { text: 'Formula Name',field_code: 'formula_name' },
        { text: 'Site', field_code: 'url' },
        { text: 'Last Modified',field_code: 'last_modified_time', format: (date: string) =>  date.split('T')[0]},
    ]

    const { query, state: queryState, actions } = useFormulaLibrary()
    const { data, isLoading, isPreviousData } = query
    const { page, limit, showAllSites, selectedSite } = queryState
    const { selectedFormulaPk } = state

    return (
        <>
            { !selectedFormulaPk &&
            <>
                <Group justify='space-between'>
                    <TextInput size='lg' w='600px' placeholder='Search by Formula PK or Name...' onChange={(e) => actions.setDebouncedSearch(e.target.value)} />
                    <Group align='flex-end'>
                        <Switch size='lg' label='All Sites' labelPosition='left' checked={showAllSites} onChange={actions.toggleShowAllSites} />
                        <Select size='lg' disabled={showAllSites} searchable value={selectedSite} data={sites} onChange={actions.setSite} />
                    </Group>
                </Group>
                <Table
                    rows={data?.rows}
                    columns={columns}
                    page={page}
                    rowCount={data?.totalCount}
                    limit={limit}
                    setLimit={limit => actions.setLimit(limit)}
                    h='calc(100vh - 265px)'
                    setPage={page => actions.setPage(page)}
                    onSelect={row => dispatch({ type: 'setSelectedFormulaPk', payload: row.formula_pk })}
                    loading={isLoading || isPreviousData}
                />
            </>}
            { !!selectedFormulaPk && <FormulaDetails state={state} dispatch={dispatch} /> }
        </>
    )
}